import { deleteData, getData, postData, putData } from "./APIServiceInterface";

export const getViewsService = (modelId) => {
    return getData(`maintenance/view/get?modelId=${modelId}`);
} 

export const createNewViewService = (payload) => {
    return putData('maintenance/view/create', payload);
}

export const saveViewService = (payload) => {
    return postData('maintenance/view/update', payload);
}

export const deleteViewService = (payload) => {
    return deleteData('maintenance/view/delete', payload);
}

export const sortViewService = async(payload) => {
    return await postData('maintenance/view/updateMultiple', payload);
}